<template>
  <div>
    <table class="prop-table mb-2">
      <tr>
        <th>Правило создания новых групп</th>
        <td>{{rule | getGroupCreationRuleName}}</td>
      </tr>
    </table>

    <p style="white-space:pre-line">{{description}}</p>
  </div>
</template>

<script>
import { getGroupCreationRuleDescription } from '../model/contest.js';
import { getGroupCreationRuleName        } from '../model/contest.js';


export default {
  name: 'GroupCreationRule',

  props: {
    rule: {
      type: Number,
      required: true,
    },
  },

  computed: {
    /** @returns {?string} */
    description() {
      return getGroupCreationRuleDescription(this.rule);
    },
  },

  filters: {
    getGroupCreationRuleName,
  },
};
</script>
